import React from 'react';
import RequireAuth from './RequireAuth';
import Layout from './Layout/Layout';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({ children }) => {
  return (
    <RequireAuth>
      <Layout>
        {children}
      </Layout>
    </RequireAuth>
  );
};

export default AuthenticatedLayout;







